module.exports = __webpack_public_path__ + "media/images/article/polygon_02-eb1c07e7220aad01a9a185fc36913762.png";